<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="115" height="15" fill="none">
    <circle cx="6" cy="8" r="6" fill="currentColor"/>
    <circle cx="22" cy="8" r="6" fill="currentColor"/>
    <circle cx="38" cy="8" r="6" fill="currentColor"/>
    <circle cx="54" cy="8" r="6" fill="currentColor"/>
    <circle cx="70" cy="8" r="6" fill="currentColor"/>
    <circle cx="86" cy="8" r="6" fill="currentColor"/>
    <circle cx="102" cy="8" r="6" fill="currentColor"/>
  </svg>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PasswordPlaceholderIcon',
});
</script>
